enum Direction {
  N = 0,
  E = 1,
  S = 2,
  W = 3,
}

export { Direction };
